import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceJob } from 'app/models/job.model';
import { EmployeeService } from 'app/services/employee.service';
import { timezone } from 'assets/constants/timezone';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-create-council',
  templateUrl: './create-council.component.html',
  styleUrls: ['./create-council.component.scss']
})
export class CreateCouncilComponent implements OnInit {

  @Input() job: InterfaceJob;
  isSaving = false;
  councilForm = new FormGroup({
    council: new FormControl(null, Validators.required),
    frecuence: new FormControl(null, Validators.required)
  });
  userId: string;
  userName: string;

  constructor(
    public ngbActiveModal: NgbActiveModal,
    protected employeeService: EmployeeService
  ) {
    this.userName = localStorage.getItem("userName") || "Not found user";
    this.userId = localStorage.getItem("userId") || "Not found user";
  }

  ngOnInit(): void {
  }

  save(): void {
    this.isSaving = true;
    const newCouncil = {
      ...this.councilForm.value,
      id: this.employeeService.createId(),
      createdById: this.userId,
      createdByName: this.userName,
      createdAt: dayjs().tz(timezone).unix(),
      jobId: this.job.id,
      jobName: this.job.name
    };
    this.employeeService.createCouncil(newCouncil).then((result: any) => {
      this.ngbActiveModal.close({
        success: true,
        result
      });
    }).catch((error: any) => {
      console.error(error);
      this.ngbActiveModal.close({
        success: false,
        error
      });
    });
  }

}
